import React from 'react';
import './css/style.scss';

import 'swiper/css';
import 'swiper/css/effect-fade';
import 'swiper/css/autoplay';
import SwiperCore, { EffectFade, Autoplay } from 'swiper';

// install Swiper modules
SwiperCore.use([EffectFade, Autoplay]);

export default function MedwikiCardV1(props) {
  return (
    <div className="w-100 medWikiCardV1Box shadow">
      <span className="graph-1" style={{ backgroundColor: '#d72b74' }}></span>
      <span className="graph-2" style={{ backgroundColor: '#d72b74' }}></span>
      <div className="crdV1topPart d-flex align-items-center justify-content-between">
        <span className="crdV1topPartGraph" style={{ backgroundColor: '#d72b74' }}></span>
        <a href="javascript:void(0)" className="text-black crdV1Speclty">
          Cardiology
          <svg className="text-primary fs-3 ms-2" strokeWidth="0" viewBox="0 0 16 16">
            <path d="M3 9.5a1.5 1.5 0 1 1 0-3 1.5 1.5 0 0 1 0 3zm5 0a1.5 1.5 0 1 1 0-3 1.5 1.5 0 0 1 0 3zm5 0a1.5 1.5 0 1 1 0-3 1.5 1.5 0 0 1 0 3z"></path>
          </svg>
        </a>
        <a href="javascript:void(0)" className="cardV1DotsMenu text-black">
          <svg className="text-black fs-2" strokeWidth="0" viewBox="0 0 1024 1024">
            <path d="M752 664c-28.5 0-54.8 10-75.4 26.7L469.4 540.8a160.68 160.68 0 0 0 0-57.6l207.2-149.9C697.2 350 723.5 360 752 360c66.2 0 120-53.8 120-120s-53.8-120-120-120-120 53.8-120 120c0 11.6 1.6 22.7 4.7 33.3L439.9 415.8C410.7 377.1 364.3 352 312 352c-88.4 0-160 71.6-160 160s71.6 160 160 160c52.3 0 98.7-25.1 127.9-63.8l196.8 142.5c-3.1 10.6-4.7 21.8-4.7 33.3 0 66.2 53.8 120 120 120s120-53.8 120-120-53.8-120-120-120zm0-476c28.7 0 52 23.3 52 52s-23.3 52-52 52-52-23.3-52-52 23.3-52 52-52zM312 600c-48.5 0-88-39.5-88-88s39.5-88 88-88 88 39.5 88 88-39.5 88-88 88zm440 236c-28.7 0-52-23.3-52-52s23.3-52 52-52 52 23.3 52 52-23.3 52-52 52z"></path>
          </svg>
        </a>
      </div>
      <div className="w-100 medWikiCardV1BoxPic">
        <img
          src="https://storage.googleapis.com/medwiki/35_server/test/thumbnail/950Ef1C0dF9ab0ADe351704cB4.png"
          alt="banner"
          className="object-fit-cover w-100 h-100 float-start"
        />
      </div>
      <div className="w-100 medWikiCrdV1Btm">
        <div className="w-100 d-flex text-start cardV1Topic">
          {/* withChanel */}
          {/* <div className="rounded-circle cardV1ProfilePic">
            <img src="https://cdn1.vectorstock.com/i/1000x1000/74/45/line-letter-m-square-logo-design-inspiration-vector-26437445.jpg" />
          </div> */}
          {/* withChanel */}

          <div className="cardV1TopicContent">
            <a href="javascript:void(0)" className="text-black fs-16 fw-medium">
              Inhalation therapy presented by IAP National Respiratory Chapte in asso...
            </a>
            <p className="text-dark fs-4">26th August 21 12:00 PM</p>
          </div>
        </div>
        <div className="w-100 cardV1Ftr d-flex align-items-center justify-content-between">
          {/* sponser logo if single ==========*/}
          <div className="crdV1sponser">
            <div className="crdV1sponserIn">
              <img src="https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcTjOsRDwZa6djQ2biIXGBJtOGHnLOB9AelrSA&usqp=CAU" />
            </div>
          </div>
          {/* sponser logo if single */}

          {/* sponser logo if multiple */}
          {/* <Swiper className="crdV1sponser"
            navigation={false}
            spaceBetween={0}
            slidesPerView={1}
            loop={true}
            autoplay={{
              "delay": 2500,
            }}
            effect={'fade'}
          >
            <SwiperSlide className="crdV1sponserIn">
              <img src="https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcTjOsRDwZa6djQ2biIXGBJtOGHnLOB9AelrSA&usqp=CAU" />
            </SwiperSlide>
            <SwiperSlide className="crdV1sponserIn">
              <img src="https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcTRdU4604IUlS1WBUZcoWM0eGOSYbFQOHD09ryLlHItgJ3jsVcP8p5YQci_a8rV7yvTeaU&usqp=CAU" />
            </SwiperSlide>
            <SwiperSlide className="crdV1sponserIn">
              <img src="https://seeklogo.com/images/M/medical-logo-4EE085437F-seeklogo.com.png" />
            </SwiperSlide>
          </Swiper> */}
          <div
            className="cardV1FtrBtn fw-medium rippleEffect rounded cursorPointer"
            onClick={props.click}
          >
            <div className="cardV1BtnHover" style={{ backgroundColor: '#d72b74' }}></div>
            <div className="cardV1BtnBorder rounded" style={{ borderColor: '#d72b74' }}></div>
            <span>Read More</span>
          </div>
        </div>
      </div>
    </div>
  );
}
